<template>
  <main class="view max-w-half">
    <div class="content pad">
      <blocks v-if="about.english" :content="JSON.parse(about.english)" />
    </div>
  </main>
</template>

<script>
// const SplitView = () =>
//   import(/* webpackChunkName: "View" */ "@/components/SplitView.vue");
const Blocks = () =>
  import(/* webpackChunkName: "Blocks" */ "@/components/Blocks.vue");
import { mapState } from "vuex";
export default {
  name: "about",
  components: {
    // SplitView,
    Blocks,
  },
  metaInfo() {
    return {
      title: "– About",
    };
  },
  created() {
    this.$store.dispatch("loadAbout");
  },
  computed: mapState(["about"]),
};
</script>
